import { isRNWebview } from 'constants/constants';
import { merge } from 'helpers/ramda';

import SETTINGS from '../actionTypes/settings';

const initialState = {
  play_deposit_video: false,
  play_withdrawal_video: false,
  show_maintenance_banner: false,
  shouldShowDegradedModeNotifyView: false,
  app_status: 'live',
  last_updated_time: 0, // to be used to update app_status, latest from api or socket will be set only
  maintenance_type: 'unscheduled',
};

// eslint-disable-next-line default-param-last
const settings = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS.GET_SETTINGS.SUCCESS:
    case SETTINGS.GET_SETTINGS_FALLBACK.SUCCESS: {
      // update if last_updated_time not available or greater than current
      const shouldUpdateAppStatus =
        !action.result.result?.last_updated_time ||
        action.result.result?.last_updated_time > state.last_updated_time;

      if (!shouldUpdateAppStatus) {
        return state;
      }

      return merge(state, {
        ...action.result.result,
        app_status: action.result.result?.app_status ?? 'live',
        last_updated_time: action.result.result?.last_updated_time ?? Date.now() * 1000,
      });
    }
    case SETTINGS.SHOW_MAINTENANCE_BANNER:
      return merge(state, {
        show_maintenance_banner: action.payload,
      });
    case SETTINGS.PLAY_DEPOSIT_VIDEO:
      return merge(state, {
        play_deposit_video: action.payload,
      });
    case SETTINGS.PLAY_WITHDRAWAL_VIDEO:
      return merge(state, {
        play_withdrawal_video: action.payload,
      });
    case SETTINGS.UPDATE_APP_STATUS: {
      // update if timestamp not available or greater than current
      const shouldUpdateAppStatus =
        !action?.payload?.timestamp ||
        action?.payload?.timestamp > state.last_updated_time;

      if (!shouldUpdateAppStatus) {
        return state;
      }

      if (
        state.app_status !== 'degraded_mode' &&
        action?.payload?.status === 'degraded_mode' &&
        !isRNWebview()
      ) {
        return merge(state, {
          shouldShowDegradedModeNotifyView: true,
          last_updated_time: action?.payload?.timestamp ?? 0,
        });
      }
      return merge(state, {
        app_status: action?.payload?.status ?? 'live',
        last_updated_time: action?.payload?.timestamp ?? 0,
        maintenance_type: action.payload?.maintenance_type ?? 'unscheduled',
        shouldShowDegradedModeNotifyView:
          action?.payload?.status === undefined || action?.payload?.status === 'live'
            ? false
            : state.shouldShowDegradedModeNotifyView,
      });
    }
    case SETTINGS.START_MAINTENANCE_SYSTEM_UPDATE: {
      const shouldUpdateAppStatus =
        !action?.payload?.timestamp ||
        action?.payload?.timestamp > state.last_updated_time;

      if (!shouldUpdateAppStatus) {
        return state;
      }

      return merge(state, {
        app_status: 'maintenance',
        maintenance_type: action.payload?.maintenance_type ?? 'unscheduled',
        maintenance_finish_time: action.payload?.maintenance_finish_time,
        last_updated_time: action?.payload?.timestamp ?? 0,
      });
    }
    case SETTINGS.START_MAINTENANCE_SYSTEM_SCHEDULED: {
      return merge(state, {
        maintenance_start_time: action.payload?.maintenance_start_time,
        maintenance_finish_time: action.payload?.maintenance_finish_time,
        maintenance_annoucement_time: action.payload?.maintenance_announcement_time,
      });
    }
    case SETTINGS.ENABLE_SERVER_DEGRADED_MODE_DISABLE_DEGRADED_MODE_NOTIFY_VIEW:
      return merge(state, {
        shouldShowDegradedModeNotifyView: false,
        app_status: 'degraded_mode',
      });
    default:
      return state;
  }
};

export default settings;
